/*
 * Copyright (C) 2018 BarD Software s.r.o
 */

import { MeInvites, TeamGet, TeamList } from './Routes';

export const NEWSLETTER_CONSENT = 1 << 0;

export interface UserDto {
    name: string;
    email: string;
    emailConsents: number;
    isRemoved?: boolean;
}

export interface TeamDto {
    refid: string;
    name: string;
    ownerId: string;
    description: string;
    creationTs: number;
    invites?: List<InviteDto>; // because if we are a participant we can't see invites
    participants: List<ParticipantDto>;
    resources: List<ResourceDto>;
    projects: List<ProjectDto>;
    budget: BudgetDto;
    billingRefid: string;
}

export interface BillingDto {
    refid: string;
    name: string;
    description: string;
    credit: number;
    freeMonthlyCredit: number;
}

export interface BillingRecordDto {
    ts: number;
    operation: string;
    amountCents: number;
    comment: string;
}

export interface BudgetDto {
    billingName: string;
    charges: number;
    monthlyLimit: number;
    credit: number;
    nextChargeTs: number;
}

export const BUDGET_DEFAULT: BudgetDto = {
    billingName: '',
    credit: 0,
    charges: 0,
    monthlyLimit: 0,
    nextChargeTs: 0,
};

export interface InviteDto {
    code: string;
    email: string;
    name: string;
    team?: TeamDto;
}

export interface ParticipantDto {
    uid: string;
    email: string;
    name: string;
}

export interface LockDto {
    uid: string;
    name: string;
    email: string;
    expirationEpochTs: number;
}

export interface ProjectDto {
    refid: string;
    name: string;
    creationTs: number;
    lock?: LockDto;
}

export interface AssignmentDto {
    taskName: string;
    projectName: string;
    startTs: number;
    endTs: number;
    load: number;
    maxSumLoad: number;
}

export interface ResourceDto {
    uid: string;
    email: string;
    name: string;
    role: string;
    phone: string;
    paymentRate: number;
}

export interface VersionDto {
    author: string;
    number: number;
    timestamp: number;
}

function sortProjects(team) {
    team.projects.sort((x: ProjectDto, y: ProjectDto) => y.creationTs - x.creationTs);
}

export function loadTeam(refid: string): JQueryPromise<TeamDto> {
    return TeamGet.invoke({
        refid,
    }).then((team) => {
        sortProjects(team);
        return team;
    });
}

export function loadOwnedTeams(): JQueryPromise<List<TeamDto>> {
    return TeamList.invoke({
        owned: true,
        participated: false,
    }).then((teams) => {
        teams.sort((x: TeamDto, y: TeamDto) => y.creationTs - x.creationTs);
        teams.forEach(sortProjects);
        return teams;
    });
}

export function loadParticipatedTeams(): JQueryPromise<List<TeamDto>> {
    return TeamList.invoke({
        owned: false,
        participated: true,
    }).then((teams) => {
        teams.sort((x: TeamDto, y: TeamDto) => y.creationTs - x.creationTs);
        teams.forEach((team) =>
            team.projects.sort((x: ProjectDto, y: ProjectDto) => y.creationTs - x.creationTs)
        );
        return teams;
    });
}

export function loadOpenInvites(): JQuery.jqXHR<List<InviteDto>> {
    return MeInvites.invoke(undefined);
}
